"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ__TextAreaContainer = exports.Occ_Textarea = exports.Occ_Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ__TextAreaContainer = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    width: ", ";\n"])), function (props) {
  if (props.size === 'small') {
    return '150px';
  } else if (props.size === 'medium') {
    return '200px';
  } else if (props.size === 'large') {
    return '250px';
  } else if (props.size === 'full') {
    return '100%';
  }
});
exports.Occ__TextAreaContainer = Occ__TextAreaContainer;
var Occ_Label = (0, _styledComponents["default"])('label')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-family: var(--font-family-primary);\n    position: absolute;\n    left: 5px;\n    font-size: var(--font-size-xxs);\n    color: ", ";\n    transition: all 0.1s ease-in-out;\n    pointer-events: none;\n    top: 5px;\n"])), function (props) {
  if (props.color === 'primary') {
    return 'var(--color-primary-highlight)';
  } else if (props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  } else if (props.color === 'error') {
    return 'var(--color-red-600)';
  } else {
    return 'var(--color-gray-800)';
  }
});
exports.Occ_Label = Occ_Label;
var Occ_Textarea = (0, _styledComponents["default"])('textarea')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    resize: none;\n    display: block;\n    height: 154px;\n    background-color: var(--color-gray-200);\n    border: transparent;\n    padding: 20px 5px 8px 5px;\n    border-top-left-radius: var(--border-radius-xs);\n    border-top-right-radius: var(--border-radius-xs);\n    width: 100%;\n    box-sizing: border-box;\n    color: ", ";\n    font-size: var(--font-size-xs);\n    border-bottom: ", ";\n\n    &:focus {\n        outline: transparent;\n        border-bottom: ", ";\n    }\n\n    &[type='number'] {\n        &::-webkit-inner-spin-button,\n        &::-webkit-outer-spin-button {\n            -webkit-appearance: none;\n        }\n    }\n"])), function (props) {
  return props.hiddenDate && 'transparent';
}, function (props) {
  if (props.hasValue) {
    if (props.color === 'secondary') {
      return '2px solid var(--color-secondary)';
    } else {
      return '2px solid var(--color-primary)';
    }
  } else {
    return '2px solid transparent';
  }
}, function (props) {
  if (props.color === 'secondary') {
    return '2px solid var(--color-secondary)';
  } else if (props.color === 'error') {
    return '2px solid var(--color-red-600)';
  } else {
    return '2px solid var(--color-primary)';
  }
});
exports.Occ_Textarea = Occ_Textarea;